import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SharedModule } from './shared/shared.module';

import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import localeES from '@angular/common/locales/es';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BotComponent } from './components/bot/bot.component';
import { BusquedaComponent } from './components/search/busqueda.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { StepperComponent } from './components/stepper/stepper.component';

//reCaptcha
import { OverlayModule } from '@angular/cdk/overlay';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { WebcamModule } from 'ngx-webcam';
import { environment } from '../environments/environment';
import { CodeValidationComponent } from './components/code-validation/code-validation.component';
import { ConfimationPagePlatformComponent } from './components/confimation-page-platform/confimation-page-platform.component';
import { ConfirmationPageComponent } from './components/confirmation-page/confirmation-page.component';
import { StepBienvenidaLtoNuevoComponent } from './components/step-bienvenida-lto-nuevo/step-bienvenida-lto-nuevo.component';
import { StepBienvenidaLtoComponent } from './components/step-bienvenida-lto/step-bienvenida-lto.component';
import { StepBienvenidaComponent } from './components/step-bienvenida/step-bienvenida.component';
import { StepCargarDocumentosComponent } from './components/step-cargar-documentos/step-cargar-documentos.component';
import { StepDatosUberLtoComponent } from './components/step-datos-uber-lto/step-datos-uber-lto.component';
import { StepDatosUberComponent } from './components/step-datos-uber/step-datos-uber.component';
import { StepDocumentosPrincipalesLtoComponent } from './components/step-documentos-principales-lto/step-documentos-principales-lto.component';
import { StepDocumentosSecundariosLtoComponent } from './components/step-documentos-secundarios-lto/step-documentos-secundarios-lto.component';
import { StepMasInformacionLtoComponent } from './components/step-mas-informacion-lto/step-mas-informacion-lto.component';
import { StepMasInformacionComponent } from './components/step-mas-informacion/step-mas-informacion.component';
import { StepSobreTiComponent } from './components/step-sobre-ti/step-sobre-ti.component';
import { StepValidacionDatosLtoComponent } from './components/step-validacion-datos-lto/step-validacion-datos-lto.component';
import { AuthInterceptor } from './core/interceptors/auth-interceptor.interceptor';
import { StepperLtoComponent } from './components/stepper-lto/stepper-lto.component';
import { StepDocumentosLtoNuevoComponent } from './components/step-documentos-lto-nuevo/step-documentos-lto-nuevo.component';
import { WelcomeStepNewComponent } from './components/welcome-step-new/welcome-step-new.component';

registerLocaleData(localeES, 'es');

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    BusquedaComponent,
    StepperComponent,
    BotComponent,
    SpinnerComponent,
    ConfirmationPageComponent,
    StepBienvenidaComponent,
    StepSobreTiComponent,
    StepDatosUberComponent,
    StepCargarDocumentosComponent,
    StepMasInformacionComponent,
    StepBienvenidaLtoComponent,
    StepDatosUberLtoComponent,
    StepDocumentosPrincipalesLtoComponent,
    StepValidacionDatosLtoComponent,
    StepDocumentosSecundariosLtoComponent,
    StepMasInformacionLtoComponent,
    CodeValidationComponent,
    StepBienvenidaLtoNuevoComponent,
    ConfimationPagePlatformComponent,
    StepperLtoComponent,
    StepDocumentosLtoNuevoComponent,
    WelcomeStepNewComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatStepperModule,
    MatRadioModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    SharedModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatDividerModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatCardModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    RecaptchaV3Module,
    WebcamModule,
    OverlayModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
